import HTTP from '../../script/service';
import store from '../store';
import Util from '../../script/util';
import { message, Modal } from 'antd';
import getZegoToken from './getZegoToken';
import { _anly_seng_custom } from '../Action';
import ZegoElectronCopyrightMusic from './zegoElectronCopyrightMusic';

// 通用错误码
const UNIVERSAL_ERROR_CODE = {
  1000017: '非法内容',
};

const REASON_ERROR_CODE = {
  1008005: '文件格式不支持',
  1008006: '路径不存在',
  1008007: '解码错误',
  1008008: '无可播放的音视频流',
};
// 房间相关错误警告
const ROOM_ERROR_CODE = {
  1002001: '登录房间数量超过上限',
  1002055: '被踢出房间',
  1002056: 'token过期被踢出房间',
};
// 录制错误
const RECORD_ERROR_CODE = {
  1010002: '文件名后缀不支持',
  1010003: '传入的参数不合法',
  1010011: '指定的录制文件路径太长，最大长度应小于 1024 字节',
  1010012: '内部错误',
  1010013: '无效的文件路径；没有文件读写权限',
  1010014: '无写入文件权限',
  1010017: '磁盘空间不足',
  1010018: '文件句柄异常',
  1010019: '输入输出异常',
};

// 推流错误
const PUBLISH_ERROR_CODE = {
  1003021: '音频采集断开，请检查网络状态',
};
// 拉流错误
const PLAY_ERROR_CODE = {
  1004007: '设备性能不足',
  1004010: '超过最大的媒体播放数量',
};

const ZEGO_ELECTRON_ERROR_CODE = {
  ...UNIVERSAL_ERROR_CODE,
  ...REASON_ERROR_CODE,
  ...ROOM_ERROR_CODE,
  ...RECORD_ERROR_CODE,
  ...PUBLISH_ERROR_CODE,
  ...PLAY_ERROR_CODE,
};

class ZegoElectronRTC {
  static instance;

  constructor(room) {
    this.isZegoRTC = true; // 是否是即构
    this.isInit = false; // 是否已初始化
    this.room = null; // 初始化时的房间参数
    this.liveConfig = null; // 房间配置
    this.events = {}; // 对应事件

    this.token = null; // 我的 TOKEN
    this.streamID = null; // 当前推流ID
    this.zegoUser = {}; // 即构所需要的用户信息
    this.slefStream = false; // 我是否己推流
    this.localStream = false; // 本地自己的流
    this.remoteStreams = []; // 所需要拉流的用户列表
    this.joined = false; // 是否已加入房间
    this.published = false; // 是否在推流中
    this.device_list = []; // 扬声器设备列表
    this.default_div = null; // 默认扬声器设备
    this.mic_list = []; // 麦克风设备列表
    this.default_mic = null; // 默认麦克风设备
    this.dev_state = true; // 扬声器状态 true 开启 false 关闭
    this.mic_state = true; // 麦克风状态 true 开启 false 关闭
    this.audio_state = false; // 伴奏状态 true 关闭 false 开启
    this.disAudio = true; // 是否静音

    this.audioVolume = 100; // 伴奏音量

    let playVolume = Util.readCookie('playVolume');
    playVolume =
      playVolume == null || isNaN(playVolume) ? 100 : parseInt(playVolume);
    if (playVolume > 150) {
      playVolume = 150;
      Util.setCookie('playVolume', 150);
    }
    this.playVolume = playVolume; // 扬声器音量

    this.speakVolume = 100; // 麦克风音量
    this.wifiDown = document.querySelector('#wifi-down'); // 拉流质量
    this.wifiUp = document.querySelector('#wifi-up'); // 推流质量

    // electron 获取的即构实例
    this.client = window.eleEvents.zgEngine;
    this.zgDefines = window.eleEvents.zgDefines;
    this.mediaPlayer = null; // 媒体播放器实例

    this.onlineUserCount = 0; // 当前房间的用户数量
    this.room = room; // 房间信息
    this.liveConfig = room.liveConfig || {};
  }

  /**
   * 链接即构
   */
  async openConn() {
    if (!this.isInit) {
      await this.initClient();
      // RTC初始化完成，开始加载即构小游戏
      this.room.events['RTC_INIT_END'] &&
        this.room.events['RTC_INIT_END'](this);

      this.isInit = true;
      this.isZegoRTC = true;
      this.setSysConfig();
      this.bindEvent();
      await this.joinChannel();
      // 版权音乐初始化
      if (this.room?.baseRoomInfo?.extInfo?.ptype === 5) {
        this.CopyrightedMusic = new ZegoElectronCopyrightMusic(this);
      }
    } else {
      // RTC初始化完成，开始加载即构小游戏
      this.room.events['RTC_INIT_END'] && this.room.events['RTC_INIT_END'](this);

      this.isZegoRTC = true;
      this.setSysConfig();
      await this.joinChannel();
      // 版权音乐初始化
      if (this.room?.baseRoomInfo?.extInfo?.ptype === 5) {
        this.CopyrightedMusic = new ZegoElectronCopyrightMusic(this);
      }
    }

    store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: true}});
    return this;
  }

  /**
   * 获取即构的 token
   * @return {Promise}
   * */
  getToken() {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await getZegoToken(this.room);
        const { token, streamIdList, userId, userName, wss } = data;
        this.token = token;
        this.zegoUser = { userID: userId, userName };
        this.server = wss;
        this.streamID = streamIdList ? streamIdList[0] : null; // 我的推流ID (游客不能推流)
        resolve(true);
      } catch (err) {
        reject(err);
      }
    });
  }

  /**
   * 初始化
   * */
  async initClient(callback) {
    // 设置引擎进阶配置。
    const advancedConfig = {
      prep_high_pass_filter: 'false',
      music_detection_mode: '2',
      auxiliary_delay_mode: '0',
      play_clear_last_frame: 'true',
    };
    if (this.room?.baseRoomInfo?.rtcMaxChannels) {
      advancedConfig.max_channels = this.room.baseRoomInfo.rtcMaxChannels
    }
    this.client.setEngineConfig({ advancedConfig });

    const instance = await Util.getAssemblyInstance();
    const { getZegoAppID } = instance.exports;
    this.client.createEngine({
      appID: getZegoAppID(process.env.CLIENT_ENV),
      scenario: this.zgDefines.ZegoScenario.HighQualityChatroom,
    });
    callback && callback();
  }

  // 基础设置
  setSysConfig() {
    // this.client.enableDebugAssistant(process.env.CLIENT_ENV !== 'production'); // 调试模式
    this.client.enableDebugAssistant(false); // 调试模式
    // this.client.uploadLog(); // 日志上传
    this.client.setLogConfig({ logPath: '' });
    this.isAudio = this.client.isFeatureSupported(
      this.zgDefines.ZegoFeatureType.Audio
    ); // 是否拥有基础音频特性
    this.isMediaPlayer = this.client.isFeatureSupported(
      this.zgDefines.ZegoFeatureType.MediaPlayer
    ); // 是否拥有媒体播放特性
    this.isMediaDataRecorder = this.client.isFeatureSupported(
      this.zgDefines.ZegoFeatureType.MediaDataRecorder
    ); // 是否拥有本地录制功能
    const config = {
      bitrate: 64,
      channel: this.zgDefines.ZegoAudioChannel.Mono,
    };
    if (this.room?.baseRoomInfo?.extInfo?.ptype === 5) {
      // 点唱房

      config.bitrate = 128;
      config.channel = this.zgDefines.ZegoAudioChannel.Stereo;
    }
    config.codecID = this.zgDefines.ZegoAudioCodecID.Low3;
    this.client.setAudioConfig(config);
    this.client.setAudioCaptureStereoMode(
      this.zgDefines.ZegoAudioCaptureStereoMode.Always
    );
    this.client.enableAGC(true);
    this.client.enableAEC(true);
    this.client.enableANS(true);
    this.client.setAECMode(this.zgDefines.ZegoAECMode.Soft);
    this.client.setANSMode(this.zgDefines.ZegoANSMode.Medium);
    this.client.setSEIConfig({
      type: this.zgDefines.ZegoSEIType.UserUnregister,
    }); // 设置SEI

    /* 互动游戏相关视频配置 */
    this.client.enableCamera(false);
    this.client.enableHardwareDecoder(false); // 是否开启硬件解码
    this.client.enableTrafficControl(
      true,
      this.zgDefines.ZegoTrafficControlProperty.AdaptiveFPS
    );
    this.client.setMinVideoFpsForTrafficControl(
      10,
      this.zgDefines.ZegoPublishChannel.Main
    );
    this.client.setTrafficControlFocusOn(
      this.zgDefines.ZegoTrafficControlFocusOnMode.LocalOnly
    );
  }

  // 绑定事件
  bindEvent() {
    // 音视频引擎状态更新的回调通知。
    this.client.on('onEngineStateUpdate', (state) => {
      if (state === this.zgDefines.ZegoEngineState.Stop) {
        this.destroyRoom(2);
      }
    });
    // 推流状态回调
    this.client.on('onPublisherStateUpdate', (info) => {
      const { streamID, state, errorCode } = info;
      if (errorCode) {
        if (errorCode === PUBLISH_ERROR_CODE['1003021']) {
          this.delToMic(3);
        }
        if (ZEGO_ELECTRON_ERROR_CODE[errorCode]) {
          message.error(ZEGO_ELECTRON_ERROR_CODE[errorCode], 5);
        }
        _anly_seng_custom(1108, { data: { streamID, state, errorCode } });
      }
    });
    // 推流质量回调
    this.client.on('onPublisherQualityUpdate', (info) => {
      const { quality } = info;
      let vaule = Number(quality.level) + 1;
      if (vaule === 6) vaule = 0;
      if (this.wifiUp) this.wifiUp.className = 'w-up d-' + vaule; // 即构与声网值相差1
    });
    // 拉流状态变更回调
    this.client.on('onPlayerStateUpdate', (info) => {
      const { streamID, state, errorCode, extendedData } = info;
      if (errorCode) {
        if (PLAY_ERROR_CODE[errorCode]) {
          message.error(PLAY_ERROR_CODE[errorCode], 5);
        }
        // 网络错误日志不统计
        if (errorCode !== 1004020) {
          _anly_seng_custom(1109, {
            data: { streamID, state, errorCode, extendedData },
          });
        }
      }
    });
    // 拉流质量回调
    this.client.on('onPlayerQualityUpdate', (info) => {
      const { quality } = info;
      let vaule = Number(quality.level) + 1;
      if (vaule === 6) vaule = 0;
      if (this.wifiDown) this.wifiDown.className = 'w-down d-' + vaule; // 即构与声网值相差1
    });
    this.client.startSoundLevelMonitorWithConfig({
      millisecond: 2000,
      enableVAD: false,
    }); // 启动音浪监听
    // 本地采集音频声浪回调
    this.client.on('onCapturedSoundLevelInfoUpdate', (soundLevelInfo) => {
      let isSpeak = false;
      if (this.mic_state && this.published && this.room.hasLive()) {
        if (soundLevelInfo.soundLevel > 10) {
          isSpeak = true;
        }
      }
      this.room.showSpeakUsersZEGO(this.room.uid, this.room.roomid, isSpeak);
    });
    // 远端拉流音频声浪回调
    this.client.on('onRemoteSoundLevelInfoUpdate', (soundLevelInfos) => {
      const speakMembers = [];
      Object.keys(soundLevelInfos).forEach((stream) => {
        if (stream) {
          const info = soundLevelInfos[stream];
          const [uid, roomid] = Util.$remoteStreamToUid(stream);
          let isSpeak = false;
          if (!!uid && info.soundLevel > 10) {
            isSpeak = true;
          }
          speakMembers.push({uid: uid, roomid, isSpeak});
        }
      });
      this.room.showSpeakUsers(speakMembers);
    });
    // 房间状态变化通知
    this.client.on('onRoomStateChanged', async (info) => {
      const { roomID, reason, errorCode, extendedData } = info;
      if (reason === this.zgDefines.ZegoRoomStateChangedReason.Logining) {
        // 正在登录房间
      } else if (reason === this.zgDefines.ZegoRoomStateChangedReason.Logined) {
        // 登陆房间成功
        if (!this.room.conn) {
          _anly_seng_custom(1114, {
            data: { roomID, msg: '云信房间实例获取失败' },
          });
          await this.destroyRoom(3);
        } else {
          this.joined = true;
          this.delToMic(2);
        }
      } else if (
        reason === this.zgDefines.ZegoRoomStateChangedReason.LoginFailed
      ) {
        // 登陆房间失败
        message.warning('登录失败');
        this.joined = false;
      } else if (
        reason === this.zgDefines.ZegoRoomStateChangedReason.Reconnecting
      ) {
        // 房间链接中断，内正在尝试重连
      } else if (
        reason === this.zgDefines.ZegoRoomStateChangedReason.Reconnected
      ) {
        // 房间重新连接成功
      } else if (
        reason === this.zgDefines.ZegoRoomStateChangedReason.ReconnectFailed
      ) {
        // 房间重新连接失败
        console.error('RTC重连失败');
        Modal.info({
          title: '系统提示',
          icon: null,
          closable: true,
          content:
            '服务器的连接因为网络原因断开了，重新连接失败，请退出房间重试。',
          className: 'daidai-confirm-style',
          okText: '确定',
          centered: true,
          onOk() {
            window.location.reload();
          },
        });
        this.joined = false;
        this.delToMic(2);
      } else if (reason === this.zgDefines.ZegoRoomStateChangedReason.KickOut) {
        // 被服务器踢出房间
        await this.destroyRoom(3);
        message.error('被踢出');
      } else if (reason === this.zgDefines.ZegoRoomStateChangedReason.Logout) {
        // 登出房间成功
        this.delToMic(2);
      } else if (
        reason === this.zgDefines.ZegoRoomStateChangedReason.LogoutFailed
      ) {
        // 登出房间失败
        message.warning('登录失败');
      }

      if (errorCode) {
        if (ZEGO_ELECTRON_ERROR_CODE[errorCode]) {
          message.error(ZEGO_ELECTRON_ERROR_CODE[errorCode]);
        }
        _anly_seng_custom(1115, {
          data: {
            token: this.token,
            roomID,
            reason,
            errorCode,
            extendedData,
          },
        });
      }
    });
    // 相同房间内其他用户推的流增加或减少的通知
    this.client.on('onRoomStreamUpdate', (info) => {
      const { updateType, streamList } = info;
      const len = streamList.length;
      for (let i = 0; i < len; i++) {
        const stream = streamList[i];
        const [uid] = Util.$remoteStreamToUid(stream.streamID);
        if (updateType === this.zgDefines.ZegoUpdateType.Add) {
          try {
            if (stream.streamID.indexOf('HYGame_') > -1) {
              if (
                this.room?.gameInteractData?.pkStatus !== 1 &&
                this.room?.gameInteractData?.pkStatus !== 3
              ) {
                _anly_seng_custom(1117, {
                  data: {
                    msg: '游戏状态异常，视频流流拉取中',
                    streamID: stream?.streamID || null,
                    roundId: this.room?.gameInteractData?.roundId || null,
                    status: this.room?.gameInteractData?.pkStatus || null,
                    roomID: this.room?.roomid || null,
                    rmode: this.room?.roomInfo?.custom?.rmode || null,
                  },
                });
              }
            } else {
              // todo 联合 IM 判断当前用户是否在麦上
              const isFind = this.room.queueList.find(
                (n) => n.account === Util.$analyToAccount(uid)
              );
              if (isFind == null) {
                console.log(
                  '=======拉流时判断用户是否在麦位上=======',
                  uid,
                  isFind,
                  this.room.queueList
                );
              }
              this.client.startPlayingStream(stream.streamID);
              this.client.setPlayStreamBufferIntervalRange(
                stream.streamID,
                300,
                4000
              ); // 设置拉流播放缓存自适应调整的区间范围
            }
          } catch (e) {
            console.error('获取媒体失败', e.toString());
            this.roomStreamUpdateErrorCount += 1;
            if (this.roomStreamUpdateErrorCount > 5) {
              _anly_seng_custom(1101, {
                data: {
                  error: e.toString(),
                  errorCode: e?.errorCode || -1,
                  message: ZEGO_ELECTRON_ERROR_CODE[e?.errorCode || -1] || '',
                  token: this.token,
                  count: this.roomStreamUpdateErrorCount,
                },
              });
              this.roomStreamUpdateErrorCount = 0;
            }
          }
        } else {
          if (stream.streamID.indexOf('HYGame_') > -1) {
            this.gameInteractPlayTime &&
              clearTimeout(this.gameInteractPlayTime);
            this.loopFindPlayDomCount = 0;
          }
          this.client.stopPlayingStream(stream.streamID);
        }
      }
    });
    // 房间 Token 鉴权将要过期的回调通知
    this.client.on('onRoomTokenWillExpire', async (info) => {
      const { remainTimeInSecond } = info;

      console.error('== roomStateChanged error count==');
      this.tokenWillExpireErrorCount += 1;
      if (this?.tokenWillExpireErrorCount > 10) {
        _anly_seng_custom(1105, {
          data: {
            token: this.token,
            remainTimeInSecond,
            renewToken: 'true',
            count: this.tokenWillExpireErrorCount,
          },
        });

        this.tokenWillExpireErrorCount = 0;
      }

      try {
        await this.getToken();
        this.client.renewToken(this.room.roomid, this.token);
        this.tokenWillExpireErrorCount = 0;
      } catch (err) {
        _anly_seng_custom(1105, {
          data: { token: this.token, expireTime: remainTimeInSecond },
        });
        Modal.confirm({
          title: '系统提示',
          icon: null,
          closable: true,
          content: '你的token权限失效，请退出房间重现进入。',
          className: 'daidai-confirm-style',
          cancelText: '取消',
          okText: '确定',
          centered: true,
          onOk() {
            window.location.reload();
          },
          onCancel() {
            window.location.reload();
          },
        });
      }
    });
    // 音频设备状态改变
    this.client.on('onAudioDeviceStateChanged', (info) => {
      const { updateType, deviceType, deviceInfo } = info;
      if (updateType === this.zgDefines.ZegoUpdateType.Add) {
        this.getDevices();
      } else {
        let isRefresh = false;
        if (deviceType === this.zgDefines.ZegoAudioDeviceType.Input) {
          // 音频输入设备
          if (deviceInfo.deviceID === this.default_mic.deviceId) {
            isRefresh = true;
          }
        } else {
          // 音频输出设备
          if (deviceInfo.deviceID === this.default_div.deviceId) {
            isRefresh = true;
          }
        }
        this.getDevices(!!this.published && isRefresh);
      }
    });
    // 本地设备异常通知
    this.client.on('onLocalDeviceExceptionOccurred', (info) => {
      const { deviceID, deviceType, exceptionType } = info;
      if (
        exceptionType ===
        this.zgDefines.ZegoDeviceExceptionType.SoundLevelTooLow
      ) {
        message.info('麦克风设备的声音过低，请检查麦克风设备', 5);
      } else if (
        exceptionType === this.zgDefines.ZegoDeviceExceptionType.InvalidId
      ) {
        if (deviceID === this.default_div.deviceId) {
          const divDeviceName = this.default_div?.devicename ?? deviceID;
          const micDeviceName = this.default_mic?.devicename ?? deviceID;
          if (deviceType === this.zgDefines.ZegoDeviceType.Microphone) {
            message.warning(
              `当前使用的麦克风${micDeviceName}设备异常，请检查或更换设备`,
              5
            );
          } else if (deviceType === this.zgDefines.ZegoDeviceType.Speaker) {
            message.warning(
              `当前使用的扬声器${divDeviceName}设备异常，请检查或更换设备`,
              5
            );
          } else if (deviceType === this.zgDefines.ZegoDeviceType.AudioDevice) {
            message.warning(
              `当前使用的${divDeviceName || micDeviceName}设备异常，请检查或更换设备`,
              5
            );
          }
        }
      } else if (
        exceptionType ===
        this.zgDefines.ZegoDeviceExceptionType.PermissionNotGranted
      ) {
        const divDeviceName = this.default_div?.devicename ?? deviceID;
        const micDeviceName = this.default_mic?.devicename ?? deviceID;
        if (deviceType === this.zgDefines.ZegoDeviceType.Microphone) {
          message.warning(
            `当前使用的${micDeviceName}无权限，请检查设备权限`,
            5
          );
        } else if (deviceType === this.zgDefines.ZegoDeviceType.Speaker) {
          message.warning(
            `当前使用的${divDeviceName}无权限，请检查设备权限`,
            5
          );
        } else if (deviceType === this.zgDefines.ZegoDeviceType.AudioDevice) {
          message.warning(
            `当前使用的${divDeviceName || micDeviceName}无权限，请检查设备权限`,
            5
          );
        }
      }
      _anly_seng_custom(1106, { data: { type: exceptionType } });
    });
    // 本地录制的状态更新回调，当录制过程状态变化时触发
    this.client.on('onCapturedDataRecordStateUpdate', (params) => {
      const { errorCode } = params;
      if (errorCode) {
        if (ZEGO_ELECTRON_ERROR_CODE[errorCode]) {
          message.error(ZEGO_ELECTRON_ERROR_CODE[errorCode], 5);
          _anly_seng_custom(1107, { data: { errorCode } });
        }
        this.events['stopAudioRecordingCallback'] &&
          this.events['stopAudioRecordingCallback']();
      }
    });
    // 录制进度更新回调
    this.client.on('onCapturedDataRecordProgressUpdate', (params) => {
      const { progress, config } = params;
      this.room.events['CHANGE_RECORDING_PROCESS'] &&
        this.room.events['CHANGE_RECORDING_PROCESS'](config, progress);
    });
    // 房间附属消息
    this.client.on('onRoomExtraInfoUpdate', ({ roomID, roomExtraInfoList }) => {
      // 小游戏
      if (window.zegoGameHall) {
        window.zegoGameHall.roomExtraInfoUpdateCallBack(
          roomID,
          roomExtraInfoList
        );
      }
    });
    // 拉流端视频接收到首帧回调
    this.client.on('onPlayerRecvVideoFirstFrame', ({ streamID }) => {
      // 互动游戏拉取视频流是否展示视频容器
      if (streamID === this.gameInteractStream?.streamID) {
        // this.room.events["GAME_INTERACT_STREAM_FIRST_FRAME"] && this.room.events["GAME_INTERACT_STREAM_FIRST_FRAME"]();
      }
    });
    // 拉流端视频接收到首帧回调
    this.client.on('onPlayerRenderVideoFirstFrame', ({ streamID }) => {
      // 互动游戏拉取视频流是否展示视频容器
      if (streamID === this.gameInteractStream?.streamID) {
        this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'] &&
          this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'](true);
      }
    });
  }

  startPlayGameStream = ({ publish264StreamId, publish265StreamId }) => {
    let streamID = publish264StreamId;
    const code265 = this.client.isVideoDecoderSupported(
      this.zgDefines.ZegoVideoCodecID.H265,
      this.zgDefines.ZegoVideoCodecBackend.Any
    );
    // const code264 = this.client.isVideoDecoderSupported(this.zgDefines.ZegoVideoCodecID.Default, this.zgDefines.ZegoVideoCodecBackend.Any);
    if (code265 && publish265StreamId && Util.checkClientVersion(318))
      streamID = publish265StreamId;
    window.gameInteractStreamID = streamID;
    // todo 互动游戏流
    if (Util.checkClientVersion(316)) {
      this.gameInteractPlayTime && clearTimeout(this.gameInteractPlayTime);
      this.loopFindPlayDomCount = 0;
      this.playGameInteractStream(streamID);
    } else {
      Util.curVersionIsUpdate(
        false,
        '请前往更新至最新版本，更好的游戏体验',
        'rtc-game-interact'
      );
    }
  };

  stopPlayGameStream = () => {
    this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'] &&
      this.room.events['GAME_INTERACT_STREAM_FIRST_FRAME'](false);
    if (!!this.gameInteractStream?.streamID) {
      this.client.stopPlayingStream(this.gameInteractStream.streamID);
    }
  };
  // 播放互动游戏视频流
  playGameInteractStream(streamID) {
    const gameVideoCanvasDom = document.querySelector('#game-video-canvas');
    if (this.loopFindPlayDomCount > 5) {
      _anly_seng_custom(1116, {
        data: {
          msg: '获取播放dom失败',
          streamID: streamID,
          dom: gameVideoCanvasDom,
          roundId: this.room?.gameInteractData?.roundId || null,
          count: this.loopFindPlayDomCount,
          status: this.room?.gameInteractData?.pkStatus || null,
        },
      });
      this.loopFindPlayDomCount = 0;
      clearTimeout(this.gameInteractPlayTime);
    } else if (gameVideoCanvasDom) {
      this.loopFindPlayDomCount = 0;
      clearTimeout(this.gameInteractPlayTime);
      // todo resourceMode OnlyRTC临时, 后期改为动态(OnlyL3)
      this.client.startPlayingStream(
        streamID,
        {
          canvas: gameVideoCanvasDom,
          viewMode: this.zgDefines.ZegoViewMode.AspectFill,
        },
        { resourceMode: this.zgDefines.ZegoStreamResourceMode.OnlyRTC }
      );

      // todo 用于互动游戏停止拉流，请勿删除
      this.gameInteractStream = { streamID: streamID };
    } else {
      this.loopFindPlayDomCount += 1;
      this.gameInteractPlayTime = setTimeout(() => {
        this.playGameInteractStream(streamID);
      }, 1500);
    }
  }

  // 麦位镜像 - 开始拉取某条流
  startMicScreenPlayStream = (streamID, isMute = false) => {
    return new Promise((resolve, reject) => {
      this.micScreenMute = isMute;

      if (!this.micScreenStreams) this.micScreenStreams = [];
      this.micScreenStreams.push(streamID);

      this.client.startPlayingStream(streamID);
      this.client.setPlayStreamBufferIntervalRange(
        streamID,
        300,
        4000
      ); // 设置拉流播放缓存自适应调整的区间范围
    })
  }
  // 停止拉取某条流
  stopPlayStream = (streamID) => {
    this.client?.stopPlayingStream?.(streamID);
    this.micScreenStreams = this.micScreenStreams.filter((item) => item !== streamID);
  }
  // 扬声器状态变更，不应该影响麦位投屏
  micScreenSpeakerChange = () => {
    if (this.micScreenMute) {
      this.muteMicScreenStream();
    }
  }
  // 静音麦位投屏
  muteMicScreenStream = (streamID = null) => {
    this.micScreenMute = true;
    if (streamID) {
      this.client.setPlayVolume(streamID, 0);
    } else {
      this.micScreenStreams.forEach((streamID) => {
        this.client.setPlayVolume(streamID, 0);
      })
    }
  }
  // 取消静音麦位投屏
  unmuteMicScreenStream = (streamID = null) => {
    this.micScreenMute = false;
    const volume = this.dev_state ? this.playVolume: 0;
    if (streamID) {
      this.client.setPlayVolume(streamID, volume);
    } else {
      this.micScreenStreams.forEach((streamID) => {
        this.client.setPlayVolume(streamID, volume);
      })
    }
  }

  /**
   * 加入房间
   * */
  async joinChannel() {
    try {
      await this.getToken();
      this.client.loginRoom(this.room.roomid, this.zegoUser, {
        isUserStatusNotify: true,
        token: this.token,
      });
      this.dev_state = true;
      this.setPlayVolume(this.playVolume);
      this.room.events['CHANGE_DEV_STATE'] &&
        this.room.events['CHANGE_DEV_STATE'](true, this.playVolume);
    } catch (err) {
      console.error('join room error:', err);
      Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: '进入当前房间失败，请重试',
        className: 'daidai-confirm-style',
        cancelText: '返回',
        okText: '确定',
        centered: true,
        onOk: () => {
          window.location.reload(true);
        },
        onCancel: () => {
          window.location.href = '/index?' + window.location.search;
        },
      });
    }
  }

  // 获取音频设备列表
  getDevices(upMic) {
    return new Promise(async (resolve) => {
      const micList = this.client.getAudioDeviceList(
        this.zgDefines.ZegoAudioDeviceType.Input
      );
      const deviceList = this.client.getAudioDeviceList(
        this.zgDefines.ZegoAudioDeviceType.Output
      );
      // 兼容声网的设备存储
      this.mic_list = micList.map((n) => ({
        deviceId: n.deviceID,
        devicename: n.deviceName,
      }));
      this.device_list = deviceList.map((n) => ({
        deviceId: n.deviceID,
        devicename: n.deviceName,
      }));
      if (upMic) {
        this.setDefaultDevices();
      }
      resolve();
    });
  }

  // 设置默认设备
  setDefaultDevices() {
    // 伴奏音量
    let audioVolume = Util.readCookie('audioVolume');
    if (audioVolume && !isNaN(audioVolume)) {
      this.audioVolume = parseInt(audioVolume);
    }
    // 扬声器音量
    let playVolume = Util.readCookie('playVolume');
    if (playVolume && !isNaN(playVolume)) {
      let curPlayVolume = parseInt(playVolume);
      if (curPlayVolume > 150) {
        curPlayVolume = 150;
        Util.setCookie('playVolume', 150);
      }
      this.playVolume = parseInt(curPlayVolume);
      this.setPlayVolume(this.playVolume);
    }
    // 麦克风音量
    let speakVolume = Util.readCookie('speakVolume');
    if (speakVolume && !isNaN(speakVolume)) {
      let curSpeakVolume = parseInt(speakVolume);
      if (curSpeakVolume > 150) {
        curSpeakVolume = 150;
        Util.setCookie('speakVolume', 150);
      }
      this.speakVolume = parseInt(curSpeakVolume);
    }

    // 设置默认设备
    // 扬声器
    let def_d = Util.readCookie('default_div_electron');
    let defaultDivID = null;
    if (def_d) {
      const defaultDiv = JSON.parse(def_d);
      defaultDivID = defaultDiv?.deviceId ?? null;
    } else {
      defaultDivID = this.client.getDefaultAudioDeviceID(
        this.zgDefines.ZegoAudioDeviceType.Output
      );
    }
    const findDiv = this.device_list.find((n) => n.deviceId === defaultDivID);
    const defaultDiv = findDiv ?? this.device_list[0];
    this.changeVoiceValue(defaultDiv);
    // 麦克风
    let def_m = Util.readCookie('default_mic_electron');
    let defaultMicID = null;
    if (def_m) {
      const defaultMic = JSON.parse(def_m);
      defaultMicID = defaultMic?.deviceId ?? null;
    } else {
      defaultMicID = this.client.getDefaultAudioDeviceID(
        this.zgDefines.ZegoAudioDeviceType.Input
      );
    }
    const findMic = this.mic_list.find((n) => n.deviceId === defaultMicID);
    const defaultMic = findMic ?? this.mic_list[0];
    this.changeVoiceSpeak(defaultMic);

    if (this.room.events['INIT_DEFAULT_PARAM']) {
      this.room.events['INIT_DEFAULT_PARAM']({
        audioVolume: this.audioVolume,
        playVolume: this.playVolume,
        speakVolume: this.speakVolume,
      });
    }
  }

  // 更新直播队列
  getLiveConfig() {
    return new Promise((resolve) => {
      //直播上报
      HTTP._mixed_channel_create({
        uid: this.room.uid,
        roomid: this.room.roomid,
        roomcid: this.room.roomid,
        creator: this.room.account,
      });
      const { rootConfig } = store.getState();
      //如果直播已经存在
      if (this.room.hasLive()) {
        this.liveConfig = {
          channelName: this.room.roomid, //房间名称
          channelId: null, //通话渠道 由网易返回
          creator: this.room.account, //直播创建者
          cid: null, //通话cid标识 由接口返回
          pushUrl: null, //推流地址
          rtmpPullUrl: null, //拉流地址
          web_version: rootConfig.version, //网页独有版本参数
          pc_version: this.room.base.clientInfo.version, //pc独有版本参数
          master_type: this.room.base.client, //主播当前终端类型
          config: [...this.room.liveConfig.config], //麦位属性配置
        };
      } else {
        this.liveConfig = {
          channelName: this.room.roomid, //房间名称
          channelId: null, //通话渠道 由网易返回
          creator: this.room.account, //直播创建者
          cid: null, //通话cid标识 由接口返回
          pushUrl: null, //推流地址
          rtmpPullUrl: null, //拉流地址
          web_version: rootConfig.version, //网页独有版本参数
          pc_version: this.room.base.clientInfo.version, //pc独有版本参数
          master_type: this.room.base.client, //主播当前终端类型
          config: [], //麦位属性配置
        };
        for (let i = 0; i < 9; i++) {
          this.liveConfig.config.push({
            index: i, //麦位
            type: i == 0 ? 0 : 1, //类型  0 主播位置 1 互动位  2 老板位
            enabled: true, // 是否启用用位置
            microphone: true, // 是否启用麦克风
            disAudio: false, //是否被静音
          });
        }
      }
      //2、发送麦位配置
      this.room.modifyConfig(this.liveConfig, false, () => {
        //3、发送1-1指令
        this.room.sendCustomMsg({
          action: '1-1',
          creator: this.room.account,
        });
        resolve();
      });
    });
  }

  /**
   * 上麦成功，上报
   * */
  joinSuccess(callback) {
    this.published = true;
    this.room.queuePoll(`queue_${this.room.uid}`);
    //如果当前在相亲模式-并且游戏进行中, 用户需要上报
    if (
      this.room.roomInfo &&
      this.room.roomInfo.custom &&
      this.room.roomInfo.custom.rmode == 1 &&
      this.room.datingData &&
      this.room.datingData.sdata
    ) {
      HTTP._addDataingUser({
        roomid: this.room.roomid,
        uids: this.room.uid,
      });
    }
    //派单房, 用户需要上报 todo 2.21.3 更改为所有房间都上报
    if (this.room.base.microType === 0) {
      if (this.room.roomInfo && this.room.roomInfo.custom) {
        let meque = this.room.queueObject[this.room.account];
        let msgId = null;
        if (
          this.room.roomInfo.custom.rmode == 6 &&
          this.room.sendOrders &&
          this.room.sendOrders.msgId
        ) {
          msgId = this.room.sendOrders.msgId;
        }
        if (meque) {
          HTTP._oneorder_upMicrophone({
            uid: this.room.uid,
            roomId: this.room.roomid,
            index: meque.index,
            msgId,
          });
        }
      }
    }

    // 初始化媒体播放器
    this.createMediaPlayer();

    if (this.CopyrightedMusic) {
      // 创建版权音乐媒体播放器
      this.CopyrightedMusic.createMusicMedia();
    }
    callback && callback();
  }

  /**
   * 切换麦克风
   * */
  changeVoiceSpeak(device) {
    if (this.isGameing && this.isGameOperateMic) {
      message.warning('游戏中无法切换麦克风');
      return;
    }
    const find = this.mic_list.find((n) => n.deviceId === device.deviceId);

    if (find) {
      this.default_mic = find;
      this.client.useAudioDevice(
        find.deviceId,
        this.zgDefines.ZegoAudioDeviceType.Input
      );
      Util.setCookie('default_mic_electron', JSON.stringify(this.default_mic));
      this.room.events['CHANGE_MIC_STATE'] &&
        this.room.events['CHANGE_MIC_STATE'](true, this.playVolume);
    }
  }

  /**
   * 开启本地麦克风设备
   * @param {boolean} open 是否静音
   * @param {boolean} operateSource 操作来源是否是游戏 true：来自游戏，可以操作， false：来自用户，不可以操作
   * @param {function} callback 回调函数
   * */
  changeMicState({ open, operateSource = false, callback = () => {} }) {
    if (this.isGameing && this.isGameOperateMic && !operateSource && open) {
      message.warning('游戏中不允许切换麦克风状态');
      return;
    }
    this.isGameOperateMic = operateSource;
    this.mic_state = !!open;
    if (this.localStream) {
      this.client.mutePublishStreamAudio(!this.mic_state);
    }
    this.room.events['CHANGE_MIC_STATE'] &&
      this.room.events['CHANGE_MIC_STATE'](this.mic_state, this.speakVolume);
    callback && callback();
  }

  /**
   * 设置麦克风音量
   * */
  setSpeakVolume(volume, isSourceClickMusic = false, callback = null) {
    if (this.isGameing && this.isGameOperateMic) {
      message.warning('游戏中无法调节麦克风音量');
      callback && callback(false);
      return;
    }
    this.mic_state = true;
    this.speakVolume = volume;
    Util.setCookie('speakVolume', volume);
    this.changeMicState({ open: this.mic_state });
    this.client.setCaptureVolume(volume);
    // 点唱房控制台可以修改麦克风音量
    if (isSourceClickMusic) {
    } // WEB端需要的逻辑，此处客户端不做处理

    callback && callback(true);
  }

  /**
   * 切换扬声器
   * */
  changeVoiceValue(device) {
    if (this.isGameing && this.isGameOperateSpeaker) {
      message.warning('游戏中无法切换扬声器');
      return;
    }
    const find = this.device_list.find((n) => n.deviceId === device.deviceId);
    if (find) {
      this.default_div = find;
      this.client.useAudioDevice(
        device.deviceId,
        this.zgDefines.ZegoAudioDeviceType.Output
      );
      Util.setCookie('default_div_electron', JSON.stringify(this.default_div));
      this.room.events['CHANGE_DEV_STATE'] &&
        this.room.events['CHANGE_DEV_STATE'](true, this.playVolume);
    }
  }
  /**
   * 设置本地扬声器是否静音
   * @param {boolean} open 是否静音
   * @param {boolean} operateSource 操作来源是否是游戏 true：来自游戏，可以操作， false：来自用户，不可以操作
   * @param {function} callback 回调函数
   * */
  changeVoiceState({ open, operateSource = false, callback = () => {} }) {
    if (this.isGameing && this.isGameOperateSpeaker && !operateSource && open) {
      message.warning('游戏中不允许切换扬声器状态');
      return;
    }
    this.isGameOperateSpeaker = operateSource;
    this.dev_state = open;
    if (!this.dev_state) {
      this.client.setAllPlayStreamVolume(0);
    } else {
      this.client.setAllPlayStreamVolume(this.playVolume);
    }
    // 麦位投屏，不跟随扬声器
    this.micScreenSpeakerChange();

    // this.client.muteSpeaker(!this.dev_state); // true: 静音 false: 非静音
    this.room.events['CHANGE_DEV_STATE'] &&
      this.room.events['CHANGE_DEV_STATE'](open, this.playVolume);
    callback && callback();
  }

  /**
   * 设置本地扬声器音量
   * */
  setPlayVolume = (volume, callback = null) => {
    if (this.isGameing && this.isGameOperateSpeaker) {
      message.warning('游戏中无法调节扬声器音量');
      callback && callback(false);
      return;
    }
    this.dev_state = true;
    this.playVolume = volume;
    Util.setCookie('playVolume', volume);
    this.changeVoiceState({open: this.dev_state})
    callback && callback(true);
  };

  /**
   * 创建本地媒体播放器
   * */
  createMediaPlayer() {
    this.mediaPlayer = this.client.createMediaPlayer();

    if (this.mediaPlayer) {
      this.mediaPlayer.enableAux(true); // 开启混音
      this.mediaPlayer.setProgressInterval(1000); // 伴奏播放进度回调间隔
      this.setAudioVolume(this.audioVolume);

      this.mediaPlayer.on(
        'onMediaPlayerStateUpdate',
        ({ state, errorCode }) => {
          if (this.playMusic) {
            // 0: 不在播放 1: 播放中 2: 暂停播放 3: 播放结束
            if (state === 1) {
              this.playMusic.playing = true;
            } else if (state === 2) {
              this.playMusic.playing = false;
            } else if (state === 3) {
              this.playMusic.playing = false;
            }
            this.events['audioMixingStateChanged'] &&
              this.events['audioMixingStateChanged'](
                this.playMusic,
                state,
                null
              );
          }
          if (errorCode !== 0) {
            if (ZEGO_ELECTRON_ERROR_CODE[errorCode]) {
              message.error(ZEGO_ELECTRON_ERROR_CODE[errorCode]);
            }
          }
        }
      );
      /*this.mediaPlayer.on("onMediaPlayerNetworkEvent", (networkEvent) => {
                console.log("-------媒体播放器网络状态事件回调------", networkEvent);
            });*/
      this.mediaPlayer.on('onMediaPlayerPlayingProgress', ({ millisecond }) => {
        if (this?.playMusic?.playing) {
          // 播放中
          this.playMusic.position = millisecond;
          this.events['audioMixingStateChanged'] &&
            this.events['audioMixingStateChanged'](this.playMusic, 1, null);
        }
      });
      /*this.mediaPlayer.on("onMediaPlayerLoadResource", (errorCode, seq) => {
                console.log("-------媒体播放器加载资源结果的通知------", errorCode, seq);
            });*/
    }
  }

  // 开始播放媒体播放器
  startAudioMixing(musicInfo, callback) {
    if (!this.events['audioMixingStateChanged']) {
      this.events['audioMixingStateChanged'] = callback;
    }

    return new Promise(async (resolve) => {
      this.changeMediaStatus(4);
      this.playMusic = musicInfo;
      const ret = await this.changeMediaResource(musicInfo.url);
      resolve(ret);
    });
  }

  /**
   * 修改媒体素材文件
   * */
  changeMediaResource(path) {
    return new Promise(async (resolve) => {
      try {
        const ret = await this.mediaPlayer.loadResource(path);
        if (ret?.errorCode && ZEGO_ELECTRON_ERROR_CODE[ret.errorCode]) {
          message.warning(ZEGO_ELECTRON_ERROR_CODE[ret.errorCode], 5);
          this.playMusic.playing = false;
          this.events['audioMixingStateChanged'] &&
            this.events['audioMixingStateChanged'](
              this.playMusic,
              0,
              ZEGO_ELECTRON_ERROR_CODE[ret.errorCode]
            );
        } else {
          this.playMusic.duration = this.mediaPlayer.getTotalDuration();
          this.playMusic.playing = false;
          this.changeMediaStatus(1);
        }
        resolve(ret);
      } catch (err) {
        console.log('媒体素材文件 err', err);
      }
    });
  }

  /**
   * 是否静音伴奏
   * @param {boolean} isMute 是否静音伴奏音量
   * */
  changeAudioMute(isMute) {
    let curVolume = this.audioVolume;
    this.audio_state = isMute;
    if (isMute) {
      curVolume = 0;
    }
    this.mediaPlayer.setVolume(curVolume); // 伴奏音量
  }

  /**
   * 设置伴奏音量
   * @param {Number} volume 伴奏音量
   * */
  setAudioVolume(volume) {
    Util.setCookie('audioVolume', volume);
    this.audioVolume = volume;
    this.mediaPlayer.setVolume(volume); // 伴奏音量
  }

  /**
   * 设置伴奏播放状态
   * @param {Number} type 播放状态 1: 开始播放 2：暂停播放 3：恢复播放 4: 停止播放
   * */
  changeMediaStatus(type) {
    let numType = Number(type);
    switch (numType) {
      case 1:
        this.mediaPlayer && this.mediaPlayer.start();
        this.playMusic.playing = true;
        break;
      case 2:
        this.mediaPlayer && this.mediaPlayer.pause();
        this.playMusic.playing = false;
        break;
      case 3:
        this.mediaPlayer && this.mediaPlayer.resume();
        this.playMusic.playing = true;
        break;
      case 4:
        this.mediaPlayer && this.mediaPlayer.stop();
        if (this.playMusic) {
          this.playMusic.playing = false;
          this.playMusic.position = 0;
        }
        break;
      default:
        this.mediaPlayer && this.mediaPlayer.stop();
        if (this.playMusic) {
          this.playMusic.playing = false;
          this.playMusic.position = 0;
        }
        break;
    }
  }

  /**
   * 设置伴奏播放模式
   * @param {Number} type 伴奏模式 1：列表循环 2： 随机播放 3: 单曲循环
   * */
  changePlayModel = (type) => {
    let numType = Number(type);
    this.mediaPlayer.enableRepeat(numType === 1);
  };

  /**
   * 解除禁言
   * */
  changeRoleToPlayer() {
    this.client.startPublishingStream(this.streamID);
    this.published = true;
    this.disAudio = false;
  }

  /**
   * 被禁言
   * */
  changeRoleToAudience() {
    this.client.stopPublishingStream();
    this.published = false;
    this.disAudio = true;
  }

  /**
   * 创建流
   * */
  createLocalStream(callback) {
    if (this.published) {
      if (this.mediaPlayer) {
        this.client.destroyMediaPlayer(this.mediaPlayer); // 销毁媒体播放器
        this.mediaPlayer = null;
      }
      if (this.CopyrightedMusic) {
        this.CopyrightedMusic.destroyMedia(); // 销毁版权音乐媒体播放器
      }
      // 1. 关闭麦克风设备
      this.changeMicState({ open: false });
      // 2. 禁止推流
      this.changeRoleToAudience();
    }
    this.changeRoleToPlayer();
    callback && callback();
  }

  /**
   * 上麦
   * */
  publishLocalStream(queue) {
    if (this.slefStream) return;
    return new Promise(async (resolve, reject) => {
      this.index = queue.index;
      this.slefStream = true;
      await this.getDevices(true);
      if (this.mic_list.length === 0) {
        this.room.closeLoading && this.room.closeLoading();
        this.slefStream = false;
        message.error(
          '未检出到你的电脑上有麦克风设备，请检查正确安装/打开后再试。',
          5
        );
        reject();
      } else {
        // 1. 创建流
        this.createLocalStream(() => {
          this.localStream = true;

          if (this.index == 0) {
            this.getLiveConfig().then(() => {
              this.joinSuccess();
            });
          } else {
            this.joinSuccess();
          }
          resolve();
          //开启麦克风
          this.changeMicState({ open: this.mic_state });
          // 设置麦克风音量
          this.client.setCaptureVolume(this.speakVolume);
          //上麦标注
          this.room.events['CHANGE_UPINMIC_STATE'] &&
            this.room.events['CHANGE_UPINMIC_STATE'](true);
          //播放器参数初始化
          if (this.room.events['INIT_LOCAL_MUSIC_PARAM']) {
            this.room.events['INIT_LOCAL_MUSIC_PARAM']({
              audioVolume: this.audioVolume,
            });
          }
        });
      }
    });
  }

  //下麦
  delToMic(n) {
    //下麦标注
    this.room.events['CHANGE_UPINMIC_STATE'] &&
      this.room.events['CHANGE_UPINMIC_STATE'](false);
    console.log('-------n--------', n);
    this.slefStream = false;
    this.localStream = false;
    this.mic_state = true;
    //关闭存在本地流
    if (this.published) {
      if (this.mediaPlayer) {
        if (this?.client?.destroyMediaPlayer) {
          this.client.destroyMediaPlayer(this.mediaPlayer);
        }
        this.mediaPlayer = null;
      }
      if (this.CopyrightedMusic) {
        this.CopyrightedMusic.destroyMedia(); // 销毁版权音乐媒体播放器
      }
      this.changeRoleToAudience();
    }
    if (this.room.hasQueume()) {
      const { microType } = store.getState();
      if (microType === 0) {
        this.room.queuePoll(this.room.account);
      } else {
        HTTP._post_server_down_microphone({
          roomId: this.room.roomid,
          operationType: 0,
        });
      }
    }
    this.room.events['CHANGE_MIC_GAME_OVER'] &&
      this.room.events['CHANGE_MIC_GAME_OVER'](n);

    // 下麦结束录音
    if (this.events['stopAudioRecordingCallback']) {
      this.events['stopAudioRecordingCallback']('录音结束，文件已保存至文件夹');
      this.client.stopRecordingCapturedData();
    }
  }

  /**
   * 开启本地录制功能
   * */
  startRecordingCapturedData(filePath, callback) {
    filePath = filePath + '/' + +new Date() + '.aac';
    this.events['stopAudioRecordingCallback'] = callback;
    this.client.startRecordingCapturedData({
      filePath,
      recordType: this.zgDefines.ZegoDataRecordType.Default,
    });
  }
  /**
   * 停止本地录制功能
   * */
  stopRecordingCapturedData() {
    this.events['stopAudioRecordingCallback'] = null;
    this.client.stopRecordingCapturedData();
  }

  /**
   * 开启/关闭系统声卡采集
   * */
  enableMixSystemPlayout(bool = false) {
    this.client.enableMixSystemPlayout(bool);
  }

  /**
   * 销毁离开房间
   * */
  destroyRoom(n) {
    this.room.webrtc = null;
    this.delToMic(3);
    // 离开房间
    console.log('destroyRoom：', n);
    if (this.CopyrightedMusic) {
      this.CopyrightedMusic.destroy(); // 销毁版权音乐
    }
    // 停止互动游戏视频拉流
    if (this.gameInteractStream?.streamID) {
      this.client.stopPublishingStream(this.gameInteractStream.streamID);
    }
    this.gameInteractStream = null;
    /*if (this?.client?.stopSoundLevelMonitor && typeof this.client.stopSoundLevelMonitor === 'function') {
            this.client.stopSoundLevelMonitor();
        }*/
    this.slefStream = false;
    this.localStream = false;
    this.joined = false;
    this.remoteStreams = [];
    this.onlineUserCount = 0;
    this.isZegoRTC = false;
    this.client && this.client.destroyEngine();

    store.dispatch({type: "RTC_LOAD_COMPLETE", data: {rtcLoadComplete: false}});
  }

  /***
   * 游戏方操作闭麦开麦
   * */
  gameOperateRTC = {
    syncGameStatus: (bool = false) => {
      this.isGameing = bool;

      if (!bool) {
        this.isGameOperateMic = false;
        this.isGameOperateSpeaker = false;
      }
    },
    // 开麦
    openMicrophone: () => {
      if (this.client && this.isGameing && this.localStream) {
        this.isGameOperateMic = true;
        this.changeMicState({ open: true, operateSource: true });
      }
    },
    // 闭麦
    closeMicrophone: () => {
      if (this.client && this.isGameing && this.localStream) {
        this.isGameOperateMic = true;
        this.changeMicState({ open: false, operateSource: true });
      }
    },
    // 开启扬声器
    openSpeaker: () => {
      if (this.client && this.isGameing) {
        this.isGameOperateSpeaker = true;
        this.changeVoiceState({ open: true, operateSource: true });
      }
    },
    // 关闭扬声器
    closeSpeaker: () => {
      if (this.client && this.isGameing) {
        this.isGameOperateSpeaker = true;
        this.changeVoiceState({ open: false, operateSource: true });
      }
    },
  };
}

export default ZegoElectronRTC;
